
@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      [saveLabel]="saveLabel"
      [isSaveEnable]="!isReadOnly"
      (save)="saveRebalance()"
      (cancel)="closeWithCheck()"><span header class="ms-header" tooltip [tooltipTitle]="rebalanceTitle" [tooltipRequiresTruncation]="true">{{rebalanceTitle}}</span></irb-editor-sidebar-banner>
      <div class="body" [style.height]="bodyHeight" #body>
        @if (data && !isUnitTest) {
          <rebalance-general-info [data]="data" [isReadOnly]="summarySource==='resultSummary'" (change)="onInputChange();" [ignoreUnsavedChanges]="ignoreUnsavedChanges"></rebalance-general-info>
        }
        <mat-accordion #accordian="matAccordion" [multi]="true">
          <mat-expansion-panel id="tlh-Setting" [expanded]="ies.getDefaultExpansionState('tlh-Setting')"
            (opened)="ies.updateExpansionState('tlh-Setting','opened')"
            (closed)="ies.updateExpansionState('tlh-Setting','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Rebalance Settings
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (!isUnitTest && !isTlhWsaEnabled) {
                <irb-harvest-tax-loss-rebalance-setting [analysisType]="analysisType" [(data)]="data" [isReadOnly]="summarySource==='resultSummary'" (change)="onInputChange();"></irb-harvest-tax-loss-rebalance-setting>
              }
              @if (!isUnitTest && isTlhWsaEnabled) {
                <irb-tlh-rebalance-settings [analysisType]="analysisType" [(data)]="data" [isReadOnly]="summarySource==='resultSummary'" (change)="onInputChange();" (closeAndNavigate)="closeAndNavigate($event)"></irb-tlh-rebalance-settings>
              }
            </ng-template>
          </mat-expansion-panel>
          <!--included poerfolio-->
          @if (summarySource!='resultSummary') {
            <mat-expansion-panel id="tlh-included-portfilio" [expanded]="ies.getDefaultExpansionState('tlh-included-portfilio')" (opened)="ies.updateExpansionState('tlh-included-portfilio','opened')" (closed)="ies.updateExpansionState('tlh-included-portfilio','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Included Portfolios
                  <span class="included-portfolios-panel-text"><span class="counter-text">{{getPortfolioCount()}}</span>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (!isUnitTest) {
                <included-portfolio #includedportfolio [data]="data" (dataChange)="smartFilterChange($event)"></included-portfolio>
              }
            </ng-template>
          </mat-expansion-panel>
        }
        <!--Scheduler-->
        @if (summarySource!='resultSummary') {
          <mat-expansion-panel id="tlh-scheduler" [expanded]="ies.getDefaultExpansionState('tlh-scheduler')" (opened)="ies.updateExpansionState('tlh-scheduler','opened')" (closed)="ies.updateExpansionState('tlh-scheduler','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Schedule
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data && !isUnitTest) {
                <rebalance-scheduler [(data)]="data" [(scheduler)]="data.scheduler" (change)="onInputChange();"></rebalance-scheduler>
              }
            </ng-template>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
}
